import React from 'react';

function ProductCard({ product, selected, addProductToList, removeProductFromList }) {
    const handleButtonClick = () => {
        if(selected) {
            removeProductFromList(product);
        }
        else {
            addProductToList(product);
        }
    }

    return (
        <div className="col-span-1 h-[238px] border border-[#EAEAEA] rounded-xl overflow-hidden flex flex-col">
            <div 
                style={{
                    backgroundImage: `url(${product.product.productImgUrls[0]})`
                }}
                className='w-full h-full bg-center bg-no-repeat bg-cover'
            />

            <h1 className="bg-[#FFFFFF] w-full p-3 font-urbanits-regular font-semibold text-base text-[#121212]">
                {product.product.productName}
            </h1>

            <button onClick={handleButtonClick} className={`w-full px-3 py-2 ${selected ? 'bg-[#EF4444]' : 'bg-primaryColor hover:bg-primaryAccent'} font-urbanist-regular font-semibold text-base text-[#FFFFFF]`}>
                {selected ?  'Remove' : 'Select'}
            </button>
        </div>
    );
}

export default ProductCard;
